import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Page from '../../components/Page';
import HandymanIcon from '@mui/icons-material/Handyman';
import Base64Encoder from './base64encoder';
import VCardMaker from './vcardmaker';
import warming_up from './warming_up';
import WhatsappPicture from './whatsappPicture';
import NumberChecker from './numberChecker';
import QRCodeGenerator from './qrCodeGenerator';
import TextFormatter from './textFormatter';
import multiCheckNumber from './multiCheckNumber';
import jsonEscapeUnescape from './jsonEscapeUnescape';


export default () => {
	return (
		<Page title={'Tools'} icon={<HandymanIcon sx={{ mr: 0.5 }} size="medium" />}>
			<Page.Wrap>
				<Switch>
					<Route path="/tools" exact component={Base64Encoder} />
					<Route path="/tools/base64encoder" exact component={Base64Encoder} />
					<Route path="/tools/vcardmaker" exact component={VCardMaker} />
					<Route path="/tools/warmingup" component={warming_up} />
					<Route path="/tools/get-whatsapp-profile-picture" exact component={WhatsappPicture} />
					<Route path="/tools/whatsapp-check-numbers" exact component={NumberChecker} />
					<Route path="/tools/whatsapp-qr-code-generator" exact component={QRCodeGenerator} />
					<Route path="/tools/whatsapp-text-formatter" exact component={TextFormatter} />
					<Route path="/tools/multi-whatsapp-check-numbers" exact component={multiCheckNumber} />
					<Route path="/tools/json-escape-unescape" exact component={jsonEscapeUnescape} />	
				</Switch>
			</Page.Wrap>
		</Page>
	);
};
